import { getQueryStringParameter, clearInputField } from '../../../helpers';

import {
  setupFatcaFiscalCountries,
  setUpFiscalTransparencyFields,
  toggleIsTaxableFields,
  toggleReasonIsNotTaxableFields,
} from '../fatca_nif_inputs';

$(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'fatca') {
    return;
  }

  setupFatcaFiscalCountries($form);
  setUpFiscalTransparencyFields($form);
  toggleIsTaxableFields($form);
  toggleReasonIsNotTaxableFields($form);

  $('.custom-control-input').each((index, checkBox) => {
    $(checkBox).on('change', (e) => {
      let $matchingReasonField = $(`#reason_for_no_fatca_nif_number_${index + 1}_field`)
      let $matchingReasonInput = $(`#users_profile_natural_reason_for_no_fatca_nif_number_${index + 1}`)

      if (e.target.checked === true) {
        $matchingReasonField.removeClass('d-none');
      } else {
        $matchingReasonField.addClass('d-none');
        clearInputField($matchingReasonInput[0]);
      }
    });
  });

  const $americanNif = $('#american-nif-field', $form);
  const $americanCitizen = $('#is-us-citizen input[type=radio]', $form);

  $americanCitizen.on('change', (e) => {
    if (e.target.value === 'true') {
      $americanNif.removeClass('d-none');
    } else {
      $americanNif.addClass('d-none');

      $('input', $americanNif).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  })
});
